module.exports = __webpack_public_path__ + "static/media/projects1.62505832.jpg";